import { Container, Divider, IconButton } from "@mui/material";
import Flexbox from "./Flexbox";
import Spacebox from "./Spacebox";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { isMobile } from "react-device-detect"
import { nav } from "../utilities";

const HomeHeader = () => {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="header" style={{ background: 'white', padding: isMobile ? '10px' : '5px', }}>
            < >
                <Flexbox alignItems="center" justifyContent="space-between">
                    <div className="logo">
                        <img src="/assets/logo.png" alt="logo" style={{ width: '40px' }} />
                    </div>
                    <Flexbox alignItems="center" className="hide-on-mid-and-small">
                        {nav.map((n, index) => (
                            <div key={index} style={{ padding: '0px 15px', margin: 'auto 5px', background: window.location.pathname === n.url ? '#f1f5f9' : 'transparent', cursor: 'pointer', borderRadius: '5px' }} onClick={() => navigate(n.url)}>
                                <small><b>{n.title}</b></small>
                            </div>
                        ))}
                    </Flexbox>
                    <Button className="hide-on-mid-and-small" style={{ borderRadius: '60px', padding: '10px 30px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                        <Flexbox alignItems="center">
                            <b>Book Consultation</b>
                            <Spacebox padding="10px" />
                            <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '20px', filter: 'invert(1)' }} />
                        </Flexbox>
                    </Button>
                    <IconButton className="hide-on-large-only" onClick={() => setIsOpen(!isOpen)}>
                        <img src="/svgs/menu.svg" alt="menu" />
                    </IconButton>
                </Flexbox>
            </>
            {isOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100dvh', background: 'white', zIndex: 100 }}>
                    <Spacebox padding="10px">
                        <Flexbox justifyContent="flex-end" alignItems="center">
                            <IconButton className="hide-on-large-only" onClick={() => setIsOpen(!isOpen)}>
                                <img src="/svgs/close.svg" alt="close" />
                            </IconButton>
                        </Flexbox>
                    </Spacebox>
                    <Divider style={{ opacity: .6 }} />
                    <Container>
                        <Spacebox padding="5px" />
                        <div>
                            {nav.map((n, index) => (
                                <div key={index} style={{ padding: '10px 15px', margin: '10px auto', background: window.location.pathname === n.url ? '#f1f5f9' : 'transparent', cursor: 'pointer', borderRadius: '5px' }} onClick={() => navigate(n.url)}>
                                    <small><b>{n.title}</b></small>
                                </div>
                            ))}
                        </div>
                        <Divider style={{ opacity: .6 }} />
                        <Spacebox padding="10px" />
                        <Button style={{ borderRadius: '5px', padding: '15px 0px', width: '100%', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                            <b>Book Consultation</b>
                        </Button>
                    </Container>
                </div>
            )}
        </div>
    );
}

export default HomeHeader;